import {
	ValidateRecaptcha,
	// ValidateInputs,
} from 'utility/Validations'

import ButtonLoader from 'utility/ButtonLoader'

declare var grecaptcha: any;

const Forms = {
	el: {
		forms: document.querySelectorAll<HTMLFormElement>('.form'),
	},
	init() {
		if (this.el.forms.length > 0) {
			Array.prototype.forEach.call(this.el.forms, item => {
				const recaptchaError = (<HTMLElement>item.querySelector('.form__recaptcha-error'))
				const submitButton = item.querySelector('[type="submit"]')

				item.addEventListener('submit', e => {
					ButtonLoader.start(submitButton)

					if (!this.handleRecaptcha(e, recaptchaError, submitButton)) {
						e.preventDefault()
						// this.handleSubmit(item)
					}
				})
			});
		}
	},
	async handleSubmit(form) {
		const formData = new FormData(form)
		// console.log(formData);


		// @ts-ignore
		const req = await fetch(
			form.getAttribute('action'),
			{
				method: form.getAttribute('method'),
				body: formData,
			}
		)
	},

	handleRecaptcha(event, element, submitButton) {
		if (element) {
			if (!element.classList.contains('hide')) {
				element.classList.add('hide')
			}

			if (!ValidateRecaptcha()) {
				event.preventDefault()
				element.classList.remove('hide')
				ButtonLoader.reset(submitButton)

				return false
			}
		}

		return true
	},
}

export default Forms
